"use client";

import { useState } from "react";
import Link from "next/link";
import { Logo } from "./Logo";
import { siteNavItems } from "@/src/lib/site-nav";

/**
 * 前台頁首：對應舊站 frontend/views/layouts/main.php 的
 * <header><nav class="navbar-main">...</nav></header>（partial 未拆檔，
 * 因舊站該段未抽 partial）。結構對齊：
 *   logo（連回首頁）→ 導覽選單 → 登入按鈕，
 * 小螢幕收合為漢堡選單（舊站 #navCollapse 行為的精簡版）。
 *
 * 「登入」先放連結佔位（/login 尚未建置，會員系統屬 B2 範圍），
 * 不在本批（B1 網站管理）動工範圍內。
 */
export function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 border-b border-amber-900/10 bg-[#f6ecd2]">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6">
        <Link href="/" className="shrink-0" onClick={() => setMobileOpen(false)}>
          <Logo />
        </Link>

        <nav aria-label="主導覽" className="hidden md:block">
          <ul className="flex items-center gap-6 text-sm text-stone-700">
            {siteNavItems.map((item) => (
              <li key={item.href}>
                <Link
                  href={item.href}
                  className="transition-colors hover:text-amber-800"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="flex items-center gap-3">
          <Link
            href="/login"
            className="hidden rounded-md bg-stone-800 px-4 py-1.5 text-sm text-white transition-colors hover:bg-stone-700 sm:inline-block"
          >
            登入
          </Link>
          <button
            type="button"
            className="inline-flex h-9 w-9 items-center justify-center rounded-md text-stone-700 md:hidden"
            aria-expanded={mobileOpen}
            aria-controls="mobile-nav"
            aria-label={mobileOpen ? "關閉選單" : "開啟選單"}
            onClick={() => setMobileOpen((v) => !v)}
          >
            <span className="sr-only">切換導覽選單</span>
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true">
              {mobileOpen ? (
                <path
                  d="M5 5l12 12M17 5L5 17"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                />
              ) : (
                <path
                  d="M3 6h16M3 11h16M3 16h16"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                />
              )}
            </svg>
          </button>
        </div>
      </div>

      {mobileOpen ? (
        <nav
          id="mobile-nav"
          aria-label="主導覽（行動版）"
          className="border-t border-amber-900/10 bg-[#f6ecd2] md:hidden"
        >
          <ul className="mx-auto flex max-w-6xl flex-col px-4 py-2 text-sm text-stone-700 sm:px-6">
            {siteNavItems.map((item) => (
              <li key={item.href}>
                <Link
                  href={item.href}
                  className="block py-2"
                  onClick={() => setMobileOpen(false)}
                >
                  {item.label}
                </Link>
              </li>
            ))}
            <li className="border-t border-amber-900/10 pt-2">
              <Link href="/login" className="block py-2" onClick={() => setMobileOpen(false)}>
                登入
              </Link>
            </li>
          </ul>
        </nav>
      ) : null}
    </header>
  );
}
